import 'babel-polyfill';
import 'url-search-params-polyfill';

import Vue from 'vue';


import 'ant-design-vue/dist/antd.less';
import '@/assets/less/main_theme.less';
import echarts from 'echarts';
import antdesign, {
  Modal,
  message,
  notification,
  Table,
} from 'ant-design-vue';
import moment from 'moment';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import router from '@/router';
import AppPage from '@/layout/AppPage.vue';
import StateManage from '../../base/stateManagement';
import ModelTable from '@/components/common/ModelTable.vue';
import chart from '@/components/common/Chart.vue';
import store from '@/vuex/store';

Vue.component('ModelTable', ModelTable);
Vue.component('chart', chart);
Vue.component(Modal.name, Modal);
Vue.component(Table.name, Table);

Vue.use(antdesign);
Vue.use(StateManage);

message.config({ top: '260px' });

Vue.prototype.$echarts = echarts;
Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$info = Modal.info;
Vue.prototype.$success = Modal.success;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$moment = moment;
Vue.prototype.$store = store;

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('login_token');
  if (token) {
    next();
  } else if (to.path == '/loginLyg') {
    next();
  } else if (to.path == '/loginGd') {
    next();
  } else if (to.path == '/loginHn') {
    next();
  } else if (to.path == '/loginLy') {
    next();
  } else if (to.path == '/loginGx') {
    next();
  } else if (to.path !== '/login' && to.path !== '/register') {
    next({
      path: '/login',
    });
  } else {
    next();
  }
});

new Vue({
  el: '#app',
  router,
  components: { AppPage },
  data: {
    zhCN,
  },
  template: '<a-locale-provider :locale="zhCN"><AppPage/></a-locale-provider>',
});



// WEBPACK FOOTER //
// ./src/entry/index/index.js